module.exports = __webpack_public_path__ + "img/Patch3.1-20170712.a67bbfe8.webp";